<template>
  <el-dialog
    v-el-drag-dialog
    :append-to-body="appendToBody"
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ApplicablePersonnel')"
    width="800px"
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :row-data="rowData"
      :check-sub-record="checkSubRecord"
      :deselect-sub-record="checkSubRecord"
      :check-main-record="false"
      style="height:400px"
    />
    <template slot="footer">
      <div style="text-align: left">
        <line-label :label="$t('SystemMaintenance.CurrentlySelectedProject') + selectRowsLabel" style="color: blue;" />
      </div>
      <div style="display: flex;justify-content: space-between;margin-top: 5px;">
        <el-checkbox v-model="checkSubRecord">{{ $t('SystemMaintenance.CheckParentCompanyWithSubsidiary') }}</el-checkbox>
        <div>
          <el-button no="confirm" type="primary" @click="onConfirm">{{ $t('common.confirm') }}</el-button>
          <el-button no="reset" @click="onReset">{{ $t('common.reset') }}</el-button>
          <el-button no="cancel" @click="innerVisible = false">{{ $t('common.cancel') }}</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ensureExecuteSuccess } from '@/utils/commonUtil'

export default {
  name: 'BranchRoleSelectDialog',
  props: {
    visible: { type: Boolean, required: true },
    value: { type: Array, required: false, default: () => [] },
    rowData: { type: Array, required: true },
    appendToBody: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      gridOptions: {
        rowSelection: 'multiple',
        groupDefaultExpanded: 1,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        treeData: true,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'code',
          width: 759,
          suppressMenu: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return this.getSelectLable(params.data)
            },
            checkbox: (params) => {
              return true
            }
          },
          tooltip: (params) => {
            return ''
          }
        },
        columnDefs: [],
        onRowSelected: (event) => {
          const rows = event.api.getSelectedRows()
          this.handleSelectRowsLabel(rows)
        },
        context: {
          componentParent: this
        }
      },
      selectRowsLabel: '',
      checkSubRecord: true
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.innerVisible) {
      this.init()
    }
  },
  methods: {
    async init() {
      await ensureExecuteSuccess(() => this.gridOptions.api)
      const nodes = this.gridOptions.api.rowModel.rootNode.allLeafChildren
      const expandedKeys = []
      if (this.value && this.value.length > 0) {
        for (const node of nodes) {
          if (this.value.includes(node.data.uuid)) {
            node.setSelected(true)
            expandedKeys.push(...node.data.path.split(','))
          } else {
            node.setSelected(false)
          }
        }
      } else {
        this.gridOptions.api.deselectAll()
      }
      this.gridOptions.api.clearFocusedCell()
      /* 默认展开第一项和选中项 */
      for (const item of nodes) {
        if (expandedKeys.includes(item.data.uuid)) {
          item.expanded = true
        } else {
          item.expanded = false
        }
      }
      const expandedNode = nodes[0]
      if (expandedNode) {
        expandedNode.expanded = true
      }
      this.gridOptions.api.onGroupExpandedOrCollapsed()
    },
    getSelectLable(data) {
      const name = this.$selectByLang(data.chineseName, data.englishName || data.chineseName)
      if (data.code) {
        return `[${data.code}]` + name
      } else {
        return name
      }
    },
    handleSelectRowsLabel(rows) {
      const labels = []
      for (const data of rows) {
        if (data.type === 4) {
          const userName = this.getSelectLable(data)
          if (!labels.includes(userName)) {
            labels.push(userName)
          }
        }
      }
      this.selectRowsLabel = labels.join(',')
    },
    onConfirm() {
      const rows = this.gridOptions.api.getSelectedRows()
      const labels = []
      for (const data of rows) {
        if (data.type === 4) {
          labels.push(data.uuid)
        }
      }
      this.$emit('callback', labels)
      this.innerVisible = false
    },
    onReset() {
      this.gridOptions.api.deselectAll()
    }
  }
}
</script>
